:host {
  --tab-item-height: var(--nav-height, 48px);
  --tab-item-min-width: max-content;
  --tab-item-color: var(--nav-color, #333333);
  --tab-item-font-size: var(--nav-size, 18px);
  --tab-item-font-weight: 500;
  --tab-item-background-color: var(--nav-background, #ffffff);
  --tab-item-active-color: var(--nav-active, #FD5000);

  display: inline-flex;
  height: var(--tab-item-height);
  line-height: var(--tab-item-height);
  min-width: var(--tab-item-min-width);
  width: max-content;
  font-weight: var(--tab-item-font-weight);
  color: var(--tab-item-color);
  font-size: var(--tab-item-font-size); 
  background-color: var(--tab-item-background-color);
  transition: color .24s ease-in-out;
}

@media screen and (max-width: 1024px) {
  :host {
    --tab-item-height: calc(var(--nav-height) - 4px);
    --tab-item-font-size: var(--nav-size-m);

  }
}

/* 选中状态 */
:host(.active:not(.disabled)) {
  text-shadow: 0 0 .65px var(--tab-item-active-color);
  color: var(--tab-item-active-color);
}

:host(.active.type--fill:not(.disabled)) {
  color: #ffffff;
}
:host(.type--fill) {
  font-weight: 700;
}
/* 选中状态 */

/* 禁用状态 */
:host(.disabled) {
  cursor: not-allowed;
  opacity: 0.6;
}
:host(.disabled) .jackery-tab-nav {
  cursor: not-allowed;
  pointer-events: none;
}
/* 禁用状态 */


:host([dark]) .jackery-tab-nav {
  background-color: var(--tab-item-dark-background-color, #242729);
}

:host([dark][disabled]) .qujackeryark-tab-nav {
  color: var(--tab-item-disabled-color, quark-formDisabledColor);
}

:host .jackery-tab-nav {
  width: 100%;
  text-align: center;
  cursor: pointer;
}